import { render, staticRenderFns } from "./ProductsSubCategoryQuickAdd.vue?vue&type=template&id=30d6f576&"
import script from "./ProductsSubCategoryQuickAdd.vue?vue&type=script&lang=js&"
export * from "./ProductsSubCategoryQuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports